import React from 'react'

const DataCenterSolutions = () => {
  return (
    <>
    <div className="container-fluid pt-5 hero-header mb-5">
  <div className="slider-container">
    <div className="slide2">
      <div className="container pt-5">
        <div className="row g-5 pt-5">
          <div className="col-lg-8 align-self-center text-center text-lg-start mb-lg-5">
            <h1 className="display-6 text-white mb-1 animated slideInRight">
            Data Center Solutions
            </h1>
            <nav aria-label="breadcrumb">
  <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
    <li className="breadcrumb-item">
      <a className="text-white" href="/">
        Home
      </a>
    </li>
    <li className="breadcrumb-item">
      <a className="text-white" href="/solutions">
        Solutions
      </a>
    </li>
    <li className="breadcrumb-item text-white active" aria-current="page">
    Data Center Solutions
    </li>
  </ol>
</nav>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    <div className="container-fluid py-5">
  <div className="container">
    <div className="row g-5 align-items-center">
      <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
        <div className="about-img about-img-cont">
          <img
            className="img-fluid"
            src="img/futuristic-computer-network-connects-global-industry-modern-warehouse-generated-by-artificial-intelligence.jpg"
          />
        </div>
        <div className="box green" />
      </div>
      <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
        <div className="btn btn-sm border rounded-pill text-warningS px-3 mb-3">
        Data Center Solutions
        </div>
        <h1 className="mb-4">
          RScom Network{" "}
          <span className="more-about-us-home">
            - Leading Provider of Flexible Network Infrastructure Solutions
          </span>
        </h1>
        <p className="mb-4">
        At RScom Network, we specialize in providing cutting-edge data center solutions designed to meet the demands of high-density computing environments. Our comprehensive range of products is meticulously engineered to ensure maximum performance, scalability, and efficiency for your data center infrastructure needs.
        </p>
        <div className="row g-3">
          <div className="col-sm-6">
            <h6 className="mb-3">
              <i className="fa fa-check text-warningS me-2" />
              Expertise
            </h6>
            <h6 className="mb-0">
              <i className="fa fa-check text-warningS me-2" />
              Quality Assurance
            </h6>
          </div>
          <div className="col-sm-6">
            <h6 className="mb-3">
              <i className="fa fa-check text-warningS me-2" />
              Scalability
            </h6>
            <h6 className="mb-0">
              <i className="fa fa-check text-warningS me-2" />
              Customer Satisfaction
            </h6>
          </div>
        </div>
        <div className="d-flex align-items-center mt-4">
          <a className="btn btn-warningS rounded-pill px-4 me-3" href="Rscom_datasheet.pdf">
            Read PDF
          </a>
          <a className="btn btn-warningS rounded-pill px-4 me-3" href="/solutions">
            See all Solutions ..
          </a>
        </div>
        
      </div>
      <h5 className="mb-0">
      Fiber Optic and Copper Infrastructure{" "}
        </h5>
        <p className="mb-0">
        Our fiber optic and copper infrastructure solutions are specifically tailored to meet the rigorous demands of modern data centers. With industry-leading reliability and performance, our products enable seamless data transmission at lightning-fast speeds. Whether you require high-bandwidth connectivity or low-latency networking, our solutions deliver unmatched performance and reliability.
        </p>
        <h5 className="mb-0">
        Modular Rack Systems{" "}
        </h5>
        <p className="mb-0">
        Our modular rack systems are engineered for scalability and efficient space utilization, allowing you to optimize your data center footprint while accommodating future growth. With flexible configuration options and robust construction, our rack systems provide the foundation for a highly adaptable and scalable data center infrastructure.
        </p>
        <h5 className="mb-0">
        Comprehensive Cabling Solutions{" "}
        </h5>
        <p className="mb-0">
        At RScom Network, we understand the critical importance of connectivity in data center environments. That's why we offer comprehensive cabling solutions that ensure seamless connectivity and maximum performance. From high-speed fiber optic cables to reliable copper cabling solutions, our products are designed to meet the most demanding requirements of modern data center environments.
        </p>
        <h5 className="mb-0">
        Learn More About Our Data Center Solutions{" "}
        </h5>
        <p className="mb-0">
        Explore our range of data center solutions to discover how RScom Network can help you build a resilient, high-performance data center infrastructure. <a href="/contact">Contact us</a> today to speak with one of our experts and discuss your specific requirements.
        </p>
    </div>
    
  </div>
</div></>
  )
}

export default DataCenterSolutions